import { useEffect, useLayoutEffect, useState } from "react";
import {
  Layout,
  Dropdown,
  Button,
  Badge,
  Avatar,
  Row,
  Col,
  // Typography,
  Modal,
  Space,
} from "antd";
import LS_SERVICE from "../../utils/localStorage";
import { THEME } from "../../constants/constent";
import { useNavigate } from "react-router-dom";
import {
  ExpandOutlined,
  FullscreenOutlined,
  LinkOutlined,
} from "@ant-design/icons"; // Import the fullscreen icon
import { displayMessage, exPostAPI } from "../../utils/common";
import { POLICY_ENABLE, VENDOR_BILL_DETAIL } from "../../constants/api";
import { ERROR_MSG_TYPE } from "../../constants/messages";
import VendorBills from "../home/v2/DashboardWidgets";
import PinnedMenu from "./PinnedMenu";

function LayoutHeader() {
  const { Header } = Layout;
  const { theme } = LS_SERVICE.get("setting") || {};
  const { website } = LS_SERVICE.get("setting") || {};
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { hnxt_hotel_id } = LS_SERVICE.get("setting") || {};

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Fullscreen function
  const enterFullScreen = () => {
    const element = document.documentElement; // To make the entire document fullscreen
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      // For Firefox
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      // For Chrome, Safari and Opera
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      // For IE/Edge
      element.msRequestFullscreen();
    }
  };

  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      // For Firefox
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      // For Chrome, Safari and Opera
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      // For IE/Edge
      document.msExitFullscreen();
    }
  };

  const toggleFullScreen = () => {
    if (document.fullscreenElement) {
      exitFullScreen(); // Exit fullscreen if already in fullscreen
    } else {
      enterFullScreen(); // Enter fullscreen
    }
  };

  const logout = () => {
    setLoading(true);
    LS_SERVICE.login_clear();
    window.location.reload();
  };

  const handleLinkClick = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };
  // const { company_name } = LS_SERVICE.get("setting") || {};
  const items = [
    {
      key: "0",
      label: (
        <Button
          style={{ width: "100%" }}
          loading={loading}
          disabled={loading}
          onClick={showModal}
        >
          Profile
        </Button>
      ),
    },
    {
      key: "1",
      label: (
        <Button
          style={{ width: "100%" }}
          disabled={loading}
          loading={loading}
          onClick={logout}
        >
          Logout
        </Button>
      ),
    },
  ];

  // Current Vendor Bills
  const [vendorBills, setVendorBills] = useState([]);
  const [loadingBills, setLoadingBills] = useState(false);
  const [enableLogin, setEnableLogin] = useState(true);

  const getVendorBill = () => {
    if (LS_SERVICE.get("user_type") === "superAdmin") {
      return;
    }
    if (!POLICY_ENABLE) {
      return;
    }

    setLoadingBills(true);

    const successFn = (data) => {
      setLoadingBills(false);
      setEnableLogin(data.enable_login);
      if (data.status && data.data) {
        setVendorBills(data.data);
      } else {
        setVendorBills([]);
        if (data.message !== "No Pending Bills") {
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
      }
    };

    const errorFn = () => {
      setLoadingBills(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to fetch vendor bills");
    };

    exPostAPI(
      `${VENDOR_BILL_DETAIL}`,
      { hnxt_hotel_id: hnxt_hotel_id },
      successFn,
      errorFn,
    );
  };

  useLayoutEffect(() => {
    getVendorBill();
  }, []);

  return (
    <>
      <Header theme="light">
        <Row
          gutter={[16, 16]}
          justify="space-between"
          style={{
            textAlign: "end",
          }}
        >
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            {/* <Title level={5}>{company_name}</Title> */}
          </Col>
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            style={{
              textAlign: "end",
            }}
          >
            <Space>
              <Avatar
                style={{
                  backgroundColor: `#${theme || THEME}`,
                }}
                onClick={() => handleLinkClick(website)}
                gap={1}
                shape="circle"
              >
                <LinkOutlined />
              </Avatar>
              <Avatar
                style={{
                  backgroundColor: `#${theme || THEME}`,
                }}
                onClick={toggleFullScreen}
                gap={1}
                shape="circle"
              >
                {document.fullscreenElement ? (
                  <FullscreenOutlined />
                ) : (
                  <ExpandOutlined />
                )}
              </Avatar>
              <Dropdown menu={{ items }} placement="bottom">
                <Avatar
                  style={{
                    backgroundColor: `#${theme || THEME}`,
                  }}
                  gap={1}
                  shape="circle"
                >
                  {LS_SERVICE.get("name")
                    ? LS_SERVICE.get("name").charAt(0).toUpperCase()
                    : ""}
                </Avatar>
              </Dropdown>
            </Space>
          </Col>
        </Row>
      </Header>

      <PinnedMenu />

      <VendorBills
        vendorBills={vendorBills}
        loadingBills={loadingBills}
        getVendorBill={getVendorBill}
        enableLogin={enableLogin} // from API response
        handleLogout={() => LS_SERVICE.clearAll()} // or your logout logic
      />

      <Modal
        title="DETAILS"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
        width={500}
        bodyStyle={{
          padding: "0px",
          textAlign: "justify",
        }}
        className="profile-modal"
      >
        <div style={{ marginBottom: "20px" }}>
          <h3
            style={{
              fontSize: "24px",
              color: "#333",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            {LS_SERVICE.get("name") +
              " (" +
              (LS_SERVICE.get("user_type") &&
              LS_SERVICE.get("user_type") !== null &&
              LS_SERVICE.get("user_type") !== undefined
                ? LS_SERVICE.get("user_type").toUpperCase()
                : "") +
              ")"}
          </h3>
          <p style={{ fontSize: "16px", color: "#777", marginBottom: "5px" }}>
            <strong>HOTEL ID:</strong> HNXT-{hnxt_hotel_id}
          </p>
          <p style={{ fontSize: "16px", color: "#777", marginBottom: "5px" }}>
            <strong>Email:</strong> {LS_SERVICE.get("email")}
          </p>
          <p style={{ fontSize: "16px", color: "#777" }}>
            <strong>Mobile:</strong> {LS_SERVICE.get("phone")}
          </p>
        </div>
        <div>
          <Button
            type="primary"
            onClick={() => {
              navigate("/profile/update");
            }}
            style={{
              width: "100%",
              color: "white",
              fontWeight: "bold",
            }}
          >
            Edit
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default LayoutHeader;
